import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ClassesOverview from "../components/ClassesOverview";
import LocationsSection from "../components/LocationsSection";
import WhatToExpect from "../components/WhatToExpect";
import FAQSection from "../components/FAQSection";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen" data-testid="homepage">
      <Header />
      
      <main>
        <HeroSection />
        <ClassesOverview />
        <WhatToExpect />
        <LocationsSection />
        <FAQSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default HomePage;
